import { render } from "./TheCartOrderReceivingPickup.vue?vue&type=template&id=4e010e0e"
import script from "./TheCartOrderReceivingPickup.vue?vue&type=script&lang=js"
export * from "./TheCartOrderReceivingPickup.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__